// extracted by mini-css-extract-plugin
export default {"endAdornmentButton":"SmsGatewaysCreateOrEditPage_endAdornmentButton__Xkbja"};